import { isSameDay } from 'date-fns'

export function formatLastMessageDateTime (date: Date): string {
  if (isSameDay(date, new Date())) {
    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false })
  }

  if (date.getTime() > Date.now() - 7 * 24 * 60 * 60 * 1000) {
    return date.toLocaleDateString('en-US', { weekday: 'short' })
  }

  return date.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })
}
